import { render, staticRenderFns } from "./AdminPermanences.vue?vue&type=template&id=16073e88"
import script from "./AdminPermanences.vue?vue&type=script&lang=js"
export * from "./AdminPermanences.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports